import {
  type ChangeEventHandler,
  type FocusEventHandler,
  type MouseEventHandler,
  type ReactElement,
} from "react";
import CHECKBOX_TRUE_VALUE from "~/constants/form/CHECKBOX_TRUE_VALUE";
import FieldError from "./FieldError";
import Label from "./Label";
import { CheckboxField } from "./CheckboxField";

export type CheckboxProps = {
  label?: string | ReactElement;
  indeterminate?: boolean;
  id: string;
  name?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  tabIndex?: number;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler;
  onClick?: MouseEventHandler;
  readOnly?: boolean;
  value?: string;
  "aria-label"?: string;
};

export default function Checkbox({
  indeterminate = false,
  required,
  id,
  name = id,
  label,
  defaultChecked,
  disabled,
  tabIndex,
  onChange,
  onClick,
  readOnly,
  checked,
  "aria-label": ariaLabel,
  error,
  value = CHECKBOX_TRUE_VALUE,
}: CheckboxProps) {
  return (
    <div>
      <div className="flex flex-row space-x-2 items-center">
        <CheckboxField
          indeterminate={indeterminate}
          required={required}
          name={name}
          id={id}
          defaultChecked={defaultChecked}
          tabIndex={tabIndex}
          onChange={onChange}
          onClick={onClick}
          readOnly={readOnly}
          checked={checked}
          aria-label={ariaLabel}
          value={value}
        />
        {label && (
          <Label
            disabled={disabled}
            id={id}
            label={label}
            required={required}
          />
        )}
      </div>
      <FieldError error={error} />
    </div>
  );
}
